import React from 'react'
import { Marker } from 'react-map-gl'

import Icon from '../../atoms/Icon'

import Button from '../../atoms/Map/SubmarketButton'

export default ({ submarket }) =>
  submarket.marketPage && submarket.marketPage.apartments.count > 0 ? (
    <Marker latitude={submarket.marketPage.center.lat} longitude={submarket.marketPage.center.lng}>
      <Button href={submarket.marketPage.slug}>
        <Icon icon='Cluster' />
        {submarket.marketPage.apartments.count}
      </Button>
    </Marker>
  ) : null
